import script from "./Attachments.vue?vue&type=script&setup=true&lang=js"
export * from "./Attachments.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&id=75f2b1a6&scoped=true&lang=css&external"
import "./Attachments.vue?vue&type=style&index=1&id=75f2b1a6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75f2b1a6"]])

export default __exports__